var Analyseis = function() {
    var block_load_more = false;

    var loadMorePastAnalyseis = function(callback) {
        var analyseis_container = $('#analyseis_container');
        Ajax.getAnalyseis(
            analyseis_container.data('eid'),
            analyseis_container.data('lid'),
            'past_more',
            analyseis_container.data('lmdt'),
            analyseis_container.data('lmid'),
            function(res) {
                if (res.success == 'ok' && res.rows) {
                    $('#analyseis_container tbody').append(res.rows);
                    analyseis_container.data('lmdt', res.last_match_dt);
                    analyseis_container.data('lmid', res.last_match_id);
                    Generic.updateTimes();
                    callback(res);
                }
            }
        );
    };

    var handleMoreClick = function() {
        $('#past_analyseis_more_btn').click(function() {
            Generic.showProgressLoader();
            loadMorePastAnalyseis(function(res) {
                if (!res.show_more) {
                    $(this).hide();
                }
                Generic.hideProgressLoader();
            });
        });
    };

    var handleScroll = function() {
        $(window).scroll(function() {
            if ($(window).scrollTop() + 3000 >= $(document).height() - $(window).height() && !block_load_more) {
                block_load_more = true;
                loadMorePastAnalyseis(function(res) {
                    if (res.show_more) {
                        block_load_more = false;
                    }
                });
            }
        });
    };

    var refreshAnalyseis = function(editor_id, league_id, current) {
        Generic.showProgressLoader();
        Ajax.getAnalyseis(
            editor_id,
            league_id,
            current ? 'current' : 'past',
            null,
            null,
            function(res) {
                if (res.success == 'ok' && res.html) {
                    $('#analyseis').html(res.html);
                    if (current) {
                        $('.ii__league_selector').removeClass('abox__btn--active');
                        $('#league_btn_' + league_id).addClass('abox__btn--active');
                    } else {
                        $('.ii__editor_selector').removeClass('abox__btn--active');
                        $('#editor_btn_' + editor_id).addClass('abox__btn--active');
                        if (res.leagues_filter_html) {
                            $('#leagues_filter').html(res.leagues_filter_html);
                            init_league_selector_handlers();
                        }
                    }
                    block_load_more = !res.show_more;
                    handleMoreClick();
                    Generic.updateTimes();
                    Generic.hideProgressLoader();
                }
            }
        );
    };

    let init_league_selector_handlers = () => {
        $('#league_selector').change(function() {
            let league_id = parseInt($(this).val());
            let editor_id = parseInt($('#analyseis_container').data('eid'));
            let current = parseInt($('#analyseis_container').data('current')) == 1; // current or past analyseis
            refreshAnalyseis(editor_id, league_id, current);
        });
        $('.ii__league_selector').click(function() {
            let league_id = parseInt($(this).data('league_id'));
            let editor_id = parseInt($('#analyseis_container').data('eid'));
            let current = parseInt($('#analyseis_container').data('current')) == 1; // current or past analyseis
            refreshAnalyseis(editor_id, league_id, current);
        });
    };

    return {
        init: function() {
            Generic.updateTimes();
            if ($('#no_more_analyseis_alert').length) {
                block_load_more = true;
            }
            if (Generic.mobile) {
                handleScroll();
            } else {
                handleMoreClick();
            }
            $('#editor_selector').change(function() {
                var editor_id = parseInt($(this).val());
                var league_id = parseInt($('#analyseis_container').data('lid'));
                var current = parseInt($('#analyseis_container').data('current')) == 1; // current or past analyseis
                refreshAnalyseis(editor_id, league_id, current);
            });
            $('.ii__editor_selector').click(function() {
                var editor_id = parseInt($(this).data('editor_id'));
                var league_id = parseInt($('#analyseis_container').data('lid'));
                var current = parseInt($('#analyseis_container').data('current')) == 1; // current or past analyseis
                refreshAnalyseis(editor_id, league_id, current);
            });

            init_league_selector_handlers();
        }
    };
}();
